import React, { useEffect, useLayoutEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Layout components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Page components
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Results from "./pages/Results";
import Contact from "./pages/Contact";
import PhotoGuide from "./pages/PhotoGuide";
import Resources from "./pages/Resources";
import BodyFatCalculator from "./pages/BodyFatCalculator";
import OneRepMaxCalculator from "./pages/OneRepMaxCalculator";
import LongevityAssessment from "./pages/LongevityAssessment";
import AdminPanel from "./pages/AdminPanel";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin panel — no header/footer */}
          <Route path="/admin" element={<><AdminPanel /><Toaster position="top-center" richColors /></>} />
          {/* Public site */}
          <Route path="*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/results" element={<Results />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/resources/body-fat-calculator" element={<BodyFatCalculator />} />
                  <Route path="/resources/one-rep-max-calculator" element={<OneRepMaxCalculator />} />
                  <Route path="/resources/longevity-assessment" element={<LongevityAssessment />} />
                  <Route path="/client/photo-guide" element={<PhotoGuide />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-center" richColors />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
